module.exports = __webpack_public_path__ + "img/aseguradora-3.ac813476.png";